module.exports = __webpack_public_path__ + "img/nodejs-development.2ddc5cb4.webp";